import React from 'react';
import { Grid, MenuItem, Select, FormControl, Typography, Box } from '@mui/material';

export const BrokerComplianceStepsFilters = ({
	stages,
	activeFilter,
	stageFilter,
	onActiveFilterChange,
	onStageFilterChange,
}) => {
	const stageOptions = React.useMemo(() => {
		if (!stages) return [];
		return stages.map((stage) => ({
			value: stage.id,
			label: stage.label || stage.id,
		}));
	}, [stages]);

	return (
		<Grid
			container
			spacing={2}
			alignItems='center'
			width={'100%'}
			sx={{ '& .MuiInputBase-root': { height: '32px' } }}
		>
			<Grid size={{ xs: 12, sm: 6, md: 2 }}>
				<FormControl fullWidth>
					<Select
						value={activeFilter}
						onChange={(e) => onActiveFilterChange(e.target.value)}
					>
						<MenuItem value='all'>All Steps</MenuItem>
						<MenuItem value='active'>Active Only</MenuItem>
						<MenuItem value='inactive'>Inactive Only</MenuItem>
					</Select>
				</FormControl>
			</Grid>
			<Grid size={{ xs: 12, sm: 6, md: 2 }}>
				<FormControl fullWidth>
					<Select
						value={stageFilter}
						onChange={(e) => onStageFilterChange(e.target.value)}
					>
						<MenuItem value='all'>All Stages</MenuItem>
						{stageOptions.map((option) => (
							<MenuItem key={option.value} value={option.value}>
								{option.label}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</Grid>
		</Grid>
	);
};
